/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerStationDtoTimeZoneRulesTransitionRulesInner } from './PartnerStationDtoTimeZoneRulesTransitionRulesInner';
import {
    PartnerStationDtoTimeZoneRulesTransitionRulesInnerFromJSON,
    PartnerStationDtoTimeZoneRulesTransitionRulesInnerFromJSONTyped,
    PartnerStationDtoTimeZoneRulesTransitionRulesInnerToJSON,
} from './PartnerStationDtoTimeZoneRulesTransitionRulesInner';
import type { PartnerStationDtoTimeZoneRulesTransitionsInner } from './PartnerStationDtoTimeZoneRulesTransitionsInner';
import {
    PartnerStationDtoTimeZoneRulesTransitionsInnerFromJSON,
    PartnerStationDtoTimeZoneRulesTransitionsInnerFromJSONTyped,
    PartnerStationDtoTimeZoneRulesTransitionsInnerToJSON,
} from './PartnerStationDtoTimeZoneRulesTransitionsInner';

/**
 * 
 * @export
 * @interface PartnerStationDtoTimeZoneRules
 */
export interface PartnerStationDtoTimeZoneRules {
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRules
     */
    fixedOffset?: boolean;
    /**
     * 
     * @type {Array<PartnerStationDtoTimeZoneRulesTransitionsInner>}
     * @memberof PartnerStationDtoTimeZoneRules
     */
    transitions?: Array<PartnerStationDtoTimeZoneRulesTransitionsInner>;
    /**
     * 
     * @type {Array<PartnerStationDtoTimeZoneRulesTransitionRulesInner>}
     * @memberof PartnerStationDtoTimeZoneRules
     */
    transitionRules?: Array<PartnerStationDtoTimeZoneRulesTransitionRulesInner>;
}

/**
 * Check if a given object implements the PartnerStationDtoTimeZoneRules interface.
 */
export function instanceOfPartnerStationDtoTimeZoneRules(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartnerStationDtoTimeZoneRulesFromJSON(json: any): PartnerStationDtoTimeZoneRules {
    return PartnerStationDtoTimeZoneRulesFromJSONTyped(json, false);
}

export function PartnerStationDtoTimeZoneRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDtoTimeZoneRules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fixedOffset': !exists(json, 'fixedOffset') ? undefined : json['fixedOffset'],
        'transitions': !exists(json, 'transitions') ? undefined : ((json['transitions'] as Array<any>).map(PartnerStationDtoTimeZoneRulesTransitionsInnerFromJSON)),
        'transitionRules': !exists(json, 'transitionRules') ? undefined : ((json['transitionRules'] as Array<any>).map(PartnerStationDtoTimeZoneRulesTransitionRulesInnerFromJSON)),
    };
}

export function PartnerStationDtoTimeZoneRulesToJSON(value?: PartnerStationDtoTimeZoneRules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fixedOffset': value.fixedOffset,
        'transitions': value.transitions === undefined ? undefined : ((value.transitions as Array<any>).map(PartnerStationDtoTimeZoneRulesTransitionsInnerToJSON)),
        'transitionRules': value.transitionRules === undefined ? undefined : ((value.transitionRules as Array<any>).map(PartnerStationDtoTimeZoneRulesTransitionRulesInnerToJSON)),
    };
}

